import React from 'react';
import styles from './SubscriptionBadge.module.scss';

const SubscriptionBadge = () => (
  <div className={styles.container}>
    <i className="far fa-sync" />
    Subscription
  </div>
);

export default SubscriptionBadge;
